import { render, staticRenderFns } from "./LabelNode.vue?vue&type=template&id=5672efd8&"
import script from "./LabelNode.vue?vue&type=script&lang=js&"
export * from "./LabelNode.vue?vue&type=script&lang=js&"
import style0 from "./LabelNode.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports